import { hasClientSession } from '../services/session';
// audit-safety-integrated
import { readJson } from '../utils/auditSafety';
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { API_BASE_URL } from "../services/api";

const RateUpdate = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const notification = location.state?.notification;

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(notification);

  useEffect(() => {
    if (notification?.id) {
      markAsRead(notification.id);
    }
    if (!notification) {
      fetchFromAPI();
    }
  }, []);

  const markAsRead = async (id) => {
    try {
      const sessionAvailable = hasClientSession();
      if (!sessionAvailable) return;
      await fetch(`${API_BASE_URL}/notifications/${id}/read`, {
        method: "PUT",
        headers: {

          "Content-Type": "application/json",
        },
      });
    } catch (err) {
      void 0;
    }
  };

  const fetchFromAPI = async () => {
    try {
      setLoading(true);
      const sessionAvailable = hasClientSession();
      if (!sessionAvailable) return;
      const res = await fetch(`${API_BASE_URL}/notifications`, {
        headers: {

          "Content-Type": "application/json",
        },
      });
      const json = await readJson(res);
      if (!json.error && json.data) {
        const rateAlt = json.data.find((n) => n.type === "Rate-Alt" && n.status === "New");
        if (rateAlt) setData(rateAlt);
      }
    } catch (err) {
      void 0;
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-gray-500">Loading...</p>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen gap-4">
        <p className="text-gray-500">No rate update data found.</p>
        <button onClick={() => navigate(-1)} className="text-blue-600 underline">
          Go back
        </button>
      </div>
    );
  }

  // Flatten all items from all categories
  const allItems = [];
  const categories = data.items || {};
  Object.entries(categories).forEach(([category, items]) => {
    Object.entries(items).forEach(([itemName, itemId]) => {
      allItems.push({ category, itemName, itemId });
    });
  });

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-6 pb-20">
      <div className="w-full max-w-2xl">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="p-2 rounded-lg bg-white shadow-sm border border-gray-200 hover:bg-gray-50 transition"
          >
            <ArrowLeft size={20} className="text-gray-600" />
          </button>
          <h1 className="text-xl font-bold text-gray-900">Rate Update Reminder</h1>
        </div>

        {/* Remarks */}
        {data.remarks && (
          <div className="bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 mb-6">
            <p className="text-sm text-amber-800 font-medium leading-relaxed">
              {data.remarks}
            </p>
          </div>
        )}

        {/* Table */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <table className="w-full text-sm table-fixed">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200">
                <th className="text-left px-4 py-3 font-semibold text-gray-600 w-16">
                  #
                </th>
                <th className="text-left px-4 py-3 font-semibold text-gray-600 w-1/3">
                  Category
                </th>
                <th className="text-left px-4 py-3 font-semibold text-gray-600">
                  Item Name
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {allItems.map((item, idx) => (
                <tr
                  key={item.itemId}
                  className="hover:bg-gray-50 transition-colors"
                >
                  <td className="px-4 py-3 text-gray-400 font-medium">
                    {idx + 1}
                  </td>
                  <td className="px-4 py-3 text-gray-500">{item.category}</td>
                  <td className="px-4 py-3 text-gray-800 font-medium">
                    {item.itemName}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="flex justify-between items-center mt-4 px-1">
          <p className="text-xs text-gray-400">
            {allItems.length} item{allItems.length !== 1 ? "s" : ""}
          </p>
          <p className="text-xs text-gray-400">
            {data.date || ""}
          </p>
        </div>
      </div>
    </div>
  );
};

export default RateUpdate;